import React, { useState } from "react";
import PDFUploader from "./components/PDFUploader";
import ResultDisplay from "./components/ResultDisplay";
import ErrorDisplay from "./components/ErrorDisplay";
import TransactionTable from "./components/TransactionTable";
import "./App.css";

function App() {
  const [total, setTotal] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleProcess = async (file) => {
    setError("");
    setTotal(null);
    setTransactions([]);
    setLoading(true);
    try {
      const { processPDF } = await import("./services/pdfProcessor");
      const result = await processPDF(file);
      setTotal(result.totalSum);
      setTransactions(result.transactions);
    } catch (err) {
      setError(err.message || "Failed to process PDF.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-container">
      <h1>Touch N Go Calculator</h1>
      <PDFUploader onProcess={handleProcess} loading={loading} />
      {error && <ErrorDisplay message={error} />}
      {total !== null && !error && <ResultDisplay total={total} />}
      {transactions.length > 0 && !error && <TransactionTable transactions={transactions} />}
    </div>
  );
}

export default App;
